import React, { Component } from "react";
import { graphql} from "gatsby";
import ReactHtmlParser from 'react-html-parser';
import Swiper, { Navigation, Pagination, Scrollbar, Autoplay, Thumbs, Mousewheel, Parallax } from 'swiper';
import "../css/style.css"
import Layout from "../components/layout";
import ProgramBannersection from "../components/program-banner-sec";
import ProgramOverviewUG from "../components/program-overview-ug";
import ProgramOverviewPG from "../components/program-overview-pg";
import ProgramStructureUG from "../components/programstructure-ug";
import ProgramStructurePG from "../components/programstructure-pg";
import PopupForm from "../components/popupForm";
import { Helmet } from "react-helmet";

Swiper.use([Navigation, Pagination, Autoplay, Scrollbar, Thumbs, Mousewheel, Parallax]);

class WorldgradProductTemplate extends Component {

    constructor(props) {
        super(props);
        this.state = {
            time: 90000000
        }
    }

    handlePopupWindow = () => {
        this.setState({ time: Math.random() })
    }

  componentDidMount(){
    
    var swiper = new Swiper('.admission-swiper', {
        autoHeight: true,
        observer: true,
        observeParents: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            observer: true,
            observeParents: true,
    
        },
        breakpoints: {
             
            320: {
    
                observer: true,
                observeParents: true,
            },
            
            480: {
    
                observer: true,
                observeParents: true,
            },
            
            768: {
    
                observer: true,
                observeParents: true,
            }
        }
    });
  }


render(){
    const post = this.props.data.wordpressWpPogramlist;
  return(
        <Layout>
            <Helmet>
                <title>{post.title} {'|'} {post.acf.list_of_university} {'|'} {post.acf.country}</title>
                <meta 
                    name="description"
                    content={post.content}
                />
            </Helmet>    

            <div style={{fontFamily: "caros"}}>
                <PopupForm time={this.state.time} />
                {
                    post.acf.degree_type === "Undergraduate" ?
                        (<ProgramBannersection
                        GraduationType={post.acf.degree_type}
                        ProgramName={post.title}
                        DegreeType={post.acf.degree_type}
                        DegreeArea={post.acf.study_area}
                        ProgramDuration={post.acf.program_dudation}
                        Term1Info={post.acf.term_1}
                        Term2Info={post.acf.term_2}
                        Year3Info={post.acf.year_2_and_3}
                        programLink={post.acf.program_page_link_}
                        ProgramSponserdImage={post.acf.university_logo.source_url !=null ? post.acf.university_logo.source_url : "" }
                        ProgramSponserdImage2={post.acf.university_sponser_img.source_url !=null ? post.acf.university_sponser_img.source_url : "" }
                        />):
                        (<ProgramBannersection
                        GraduationType={post.acf.degree_type}
                        ProgramName={post.title}
                        DegreeType={post.acf.degree_type}
                        DegreeArea={post.acf.study_area}
                        ProgramDuration={post.acf.program_dudation}
                        ProgramSponserdImage={post.acf.university_logo.source_url !=null ? post.acf.university_logo.source_url : ""}
                        ProgramSponserdImage2={post.acf.university_sponser_img.source_url !=null ? post.acf.university_sponser_img.source_url : "" }
                        /> )
                }
            </div>


            <section className="py-5" style={{backgroundColor: "#fff"}}>
                <div className="container">
                    <div className="row mx-0 justify-content-between university-detail-features-container px-0">
                        <div className="col-md-5 program-detail-features d-flex align-items-center">
                            <div>
                                <h5> University Fees </h5>
                                <p> {post.acf.employability_university_fees} </p>
                                <img
                                    className="university-detail-features-svg"
                                    src="https://media.publit.io/file/TheWorldgrad/3Institutions/Common/Total-costsaving-1.png"
                                    alt="Location SVG"
                                />
                            </div>
                        </div>

                        <div className="col-md-5 program-detail-features d-flex align-items-center">
                            <div>
                                <h5> Median salary </h5>
                                <p> {post.acf.employability_median_salary}</p>
                                <img
                                    className="university-detail-features-svg"
                                    src="https://media.publit.io/file/TheWorldgrad/3Institutions/Common/money-bag.svg"
                                    alt="Location SVG"
                                />
                            </div>
                        </div>

                        <div className="col-md-5 program-detail-features d-flex align-items-center">
                            <div>
                                <h5> Career prospects </h5>
                                <p> {post.acf.employability_job_prospects}</p>
                                <img
                                    className="university-detail-features-svg"
                                    src="https://media.publit.io/file/TheWorldgrad/3Institutions/Common/Career-prospects-1.png"
                                    alt="Location SVG"
                                />
                            </div>
                        </div>

                        <div className="col-md-5 program-detail-features d-flex align-items-center">
                            <div>
                                <h5> Post Study Work Rights Duration </h5>
                                <p> {post.acf.employability_post_study_work_rights} </p>
                                <img
                                    className="university-detail-features-svg"
                                    src="https://media.publit.io/file/TheWorldgrad/3Institutions/Common/Post-Study-Work-Rights-Duration-duration-1.png"
                                    alt="Location SVG"
                                />
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            <section className="py-5">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <div class="progam-overview-box mb-0">
                                <h3 className="text-center text-md-left">Program overview</h3>
                                <p>{ReactHtmlParser(post.acf.program_overview)}</p>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </section>

            <div>
                <section class="progam-overview-sec pb-5 pt-2 pt-md-5" style={{backgroundColor: "#fff"}}>
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                {/* <div class="progam-overview-box">
                                    <h3 className="text-center text-md-left">Program overview</h3>
                                        <p>{ReactHtmlParser(post.acf.program_overview)}</p>
                                </div>
                                <a class="btn-default mx-auto mb-0 mt-3 mb-md-5" href={post.acf.course_overview_link} target="_blank">course overview</a> */}
                                {post.acf.degree_type === "Undergraduate" ?
                                    <ProgramOverviewUG
                                        QualificationInfo={post.acf.academic_requirments}
                                        EnglishRequirments={post.acf.english_requirments}
                                        OtherRequirments={post.acf.other_requirments}
                                        OnlineFees={post.acf.online_fees }
                                        CampusFees={ ReactHtmlParser(post.acf.offline_fees)}
                                    />
                                :
                                <ProgramOverviewPG
                                DirectAcadenic={post.direct_academic_requirements}
                                DirectEnglish={post.direct_english_requirements}
                                DirectOther={post.direct_other_requirments}
                                QualificationInfo={post.acf.academic_requirments}
                                EnglishRequirments={post.acf.english_requirments}
                                OtherRequirments={post.acf.other_requirments}
                                OnlineFees={post.acf.online_fees}
                                CampusFees={ ReactHtmlParser(post.acf.offline_fees)}
                                />}
                                <a class="btn-default mx-auto mt-3" href={post.acf.course_overview_link} target="_blank">course overview</a>
                            </div>
                        </div>
                    </div>
                </section>           
            </div>
           
            <div class="campus-learning-sec pb-5 pt-2 pt-md-5">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            {/* <div class="title"> */}
                                <h3 className="text-center text-md-left">Program Structure </h3>
                            {/* </div> */}
                            {post.acf.degree_type ==="Undergraduate" ?
                       ( <ProgramStructureUG
                        Term1Info={post.acf.term_1}
                        UniversityName={post.acf.list_of_university}
                        subjectInfo={post.acf.subject_information.map((eachBenifits, i) =>
                            i < 4? (
                                <ul>
                                <li>
                                    <p><strong>{i+1}. </strong> {eachBenifits.subject_information}</p>
                                </li>
                                </ul>
                            ) : (
                              ""
                            )
                          )}
                        Term2Info={post.acf.term_2}
                        Term3Info={post.acf.year_2_and_3}
                    />) :(
                        <ProgramStructurePG
                    Term1Info={post.acf.term_1}
                    subjectInfo={post.acf.subject_information.map((eachBenifits, i) =>
                        i < 4? (
                            <ul>
                            <li>
                                <p><strong>{i+1}. </strong> {eachBenifits.subject_information}</p>
                            </li>
                            </ul>
                        ) : (
                          ""
                        )
                      )}
                    UniversityName={post.acf.list_of_university}
                    Term3Info={post.acf.year_2_and_3}
                />
                    )   
                        }
                            
                            </div>
                    </div>
                </div>
            </div>
                
            <div class="progam-overview-sec admission-process-sec pb-5 pt-2 pt-md-5">
                <div class="container">
                    <div class="row">
                        <div class="col-12"> 
                            <div class="online-journey-inner">
                                <div class="row"> 
                                    <div class="col-md-6">
                                        <div class="swiper-container admission-swiper">
                                            <div class="swiper-wrapper">
                                                <div class="swiper-slide">
                                                    <div class="image-holder wow fadeInLeft" data-wow-duration="1s" data-wow-delay=".1s">
                                                      <img src="https://media.publit.io/file/TheWorldgrad/2Programdetailedpage/sample_offer_letter__NEW-min_yvqyd3.png" alt="" class="img-fluid" />
                                                    </div>
                                                </div>
                                             
                                            </div>
                                            
                                            <div class="swiper-pagination"></div>
                                        </div> 
                                    </div>
                                    <div class="col-md-6">
                                        <div class="text-box wow fadeInRight pt-0" data-wow-duration="1s" data-wow-delay=".2s">
                                            <h3 className="text-center text-md-left">Admissions process</h3> 
                                            <ul>
                                                <li>
                                                    <h4>Choose a program</h4>
                                                    <span>With the help of our admissions team, select a program of your choice from our wide set of globally ranked partners</span>
                                                </li>
                                                <li>
                                                    <h4>Submit Application</h4>
                                                    <span>Fill out our online application form along with the necessary documents. Our admissions team will guide you through the process.</span>
                                                </li>
                                                <li>
                                                    <h4>Receive admission offer</h4>
                                                    <span>Once your application is approved by The WorldGrad and our partner institution, you will receive an offer for enrolment for the online program as well as the on campus component. Offers can be made within 24hrs of receiving an adequately filled application.</span>
                                                </li>
                                                <li>
                                                    <h4>Confirm enrolment</h4>
                                                    <span>Accept your offer by submitting a confirmation fee of INR 25,000 within 5 days of receiving the admission offer. Since we have limited seats, enrolment would be void if confirmation fee is not received as stated. </span>
                                                </li>
                                            </ul> 
                                          {/* <a class="btn-default mx-auto" onClick={() => this.handlePopupWindow()}>Speak With Us</a> */}
                                        </div>
                                    </div> 
                                </div> 
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="progam-overview-sec assurance-sec pb-5 pt-2 pt-md-5">
                <div class="container">
                    <div class="row">
                        <div class="col-12"> 
                            <div class="online-journey-inner">
                                <div class="row"> 
                                    <div class="col-md-6">
                                        <div class="text-box wow fadeInLeft pl-0" data-wow-duration="1s" data-wow-delay=".2s">
                                            <h3>The WorldGrad is Your Smartest Path to an Overseas Education</h3> 
                                            <p>We provide end-to-end support to help you reach your education goals</p>
                                            <ul className="mb-3 mb-md-0">
                                                <li>
                                                    <h4>Language Support</h4>
                                                    <span>Our english preparation and support programs will ensure that language is no longer a barrier to your academic success</span>
                                                </li>
                                                <li>
                                                    <h4>Visa Advice & Support</h4>
                                                    <span>consult with our experts to maximise your chances of getting a student visa</span>
                                                </li>
                                                <li>
                                                    <h4>Education Loans</h4>
                                                    <span>We have partnered with specialised education loan providers so you can secure the financial support needed</span>
                                                </li> 
                                            </ul> 
                                          {/* <a class="btn-default mx-auto" onClick={() => this.handlePopupWindow()}>Speak With Us</a> */}
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="image-holder wow fadeInRight" data-wow-duration="1s" data-wow-delay=".1s">
                                          <img src="https://media.publit.io/file/TheWorldgrad/1Homepage/6theworldgradisyour/Screenshot-243.png" alt="" class="img-fluid" />
                                        </div>
                                    </div>
                                </div> 
                            </div>
                        </div>
                    </div>
                </div>
            </div>
      </Layout>
  )
}

}

export default WorldgradProductTemplate;

export const WorldgradProductsQuery = graphql`
query currentWorldgradProductQuery( $id: String!){
    wordpressWpPogramlist(id: { eq: $id }) {
            title
            content
            type
            slug
            wordpress_id
            acf {
                university_logo
              {
                source_url
              }
              employability_job_prospects
              employability_median_salary
              employability_post_study_work_rights
              employability_university_fees
              course_overview_link
              program_page_link_
                university_sponser_img
                {
                  source_url
                }
          subject_information
          {
            subject_information
          }
          study_area
              list_of_university
              program_overview
              country
              degree_type
              academic_requirments
              english_requirments
              other_requirments
              program_dudation
              online_fees
              offline_fees
              list_of_university
              short_eligibility
              term_1
              term_2
              university_ranking
              year_2_and_3
              you_save
            }
          }
        }
`